module.exports = __webpack_public_path__ + "img/artless-logo-negro.e1d209a9.svg";